import { render, staticRenderFns } from "./FeedbackReportRatingCard.vue?vue&type=template&id=167a5b20&scoped=true&"
import script from "./FeedbackReportRatingCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackReportRatingCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackReportRatingCard.vue?vue&type=style&index=0&id=167a5b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a5b20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRating,VRow})
